@if (currentTimezone(); as currentTimezone) {
  <div class="flex flex-col justify-between">
    <div class="flex flex-col gap-1 py-2">
      <div class="text-xl leading-none font-semibold tracking-tight">Fuseau horaire</div>
      <div class="text-gray-11">{{ currentTimezone.timezone }}</div>
    </div>
  </div>
}
